import { useTranslation } from 'react-i18next';
import { uiLanguageFromI18n, UiLanguage } from './language.config';

/** The interface language as the app names it (`srb`/`eng`), re-rendering on a switch. */
export const useUiLanguage = (): UiLanguage => {
  const { i18n } = useTranslation();
  return uiLanguageFromI18n(i18n.language);
};
